import { JE_FCValidationNode, JE_JsonValidationContext, JE_JsonValidationErrorReportType } from "../interfaces";

export const validateClaimExists = (vCtx: JE_JsonValidationContext, node: JE_FCValidationNode, claimId: string) => {
    if (!vCtx.claims.hasOwnProperty(claimId)) {
      addNodeErrorReport(node.nodeId, vCtx, `Unknown claim ID '${claimId}' referenced in node`);
      return false;
    } else {
      return true;
    }
};
  
export const validateClaimIsSet = (
    vCtx: JE_JsonValidationContext,
    node: JE_FCValidationNode,
    claimId: string,
    claimDesc: string,
    defaultValue?: string,
    localNodeClaims?: Set<string>,
    localSAClaims?: Set<string>,
) => {
    if (
      !localNodeClaims?.has(claimId) &&
      !localSAClaims?.has(claimId) &&
      (defaultValue === undefined || defaultValue === null)
    ) {
      if (!node.parentEmittedClaims.has(claimId)) {
        let errMsg = `Claim '${claimId}' ${claimDesc} not set in any preceding node`;
        if (vCtx.flowcharts[node.flowId].flowType === 'emailVerificationSendAction') {
          errMsg = `${errMsg} (Note: Inside custom email verification flows, user input claim values from the same parent User Input Page, other than the email claim to verify, are not available)`;
        }
        addNodeErrorReport(node.nodeId, vCtx, errMsg);
      } else {
        let missingParents = Object.keys(node.availableClaimsByParent).filter((k) => {
          return !node.availableClaimsByParent[k].has(claimId);
        });
        missingParents.forEach((mpId) => {
          addNodeErrorReport(
            node.nodeId,
            vCtx,
            `Claim '${claimId}' ${claimDesc} is not set in some preceding path through parent node '${vCtx.nodes[mpId].displayLabel}'`,
          );
        });
      }
    }
};
  
export const validateClaimPresence = (
    vCtx: JE_JsonValidationContext,
    node: JE_FCValidationNode,
    claimId: string,
    claimFieldName: string,
    claimDesc: string,
    mustBeSet: boolean,
    defaultValue?: string,
    localNodeClaims?: Set<string>,
    localSAClaims?: Set<string>,
) => {
    if (claimId) {
      if (validateClaimExists(vCtx, node, claimId) && mustBeSet) {
        validateClaimIsSet(vCtx, node, claimId, claimDesc, defaultValue, localNodeClaims, localSAClaims);
      }
    } else {
      addNodeErrorReport(node.nodeId, vCtx, `${claimFieldName} is not selected`);
    }
};

export const claimHasDataType = (
    vCtx: JE_JsonValidationContext,
    claimId: string,
    dataType: string
) => {
    return vCtx.claims[claimId]?.dataType === dataType;
}

export const addErrorReport = (
    vCtx: JE_JsonValidationContext,
    reportType: JE_JsonValidationErrorReportType,
    reportId: string,
    errMsg: string,
    isError: boolean,
    flowId?: string,
    componentType?: string,
) => {
    if (reportType === 'node') {
      if (!vCtx.errors.nodeErrors.hasOwnProperty(reportId)) {
        vCtx.errors.nodeErrors[reportId] = {
          reportType: 'node',
          flowId: flowId,
          flowDisplayName: vCtx.flowcharts[flowId!].flowName,
          nodeId: reportId,
          componentType: componentType,
          errors: [],
          warnings: [],
        };
      }
      if (isError) {
        vCtx.errors.nodeErrors[reportId].errors.push(errMsg);
      } else {
        vCtx.errors.nodeErrors[reportId].warnings.push(errMsg);
      }
    } else if (reportType === 'claim') {
      if (!vCtx.errors.claimsErrors.hasOwnProperty(reportId)) {
        vCtx.errors.claimsErrors[reportId] = {
          reportType: 'claim',
          claimId: reportId,
          errors: [],
          warnings: [],
        };
      }
      if (isError) {
        vCtx.errors.claimsErrors[reportId].errors.push(errMsg);
      } else {
        vCtx.errors.claimsErrors[reportId].warnings.push(errMsg);
      }
    }
};
  
export const addClaimErrorReport = (claimId: string, vCtx: JE_JsonValidationContext, errMsg: string, error?: boolean) => {
    addErrorReport(vCtx, 'claim', claimId, errMsg, error !== undefined ? error : true);
};
  
export const addNodeErrorReport = (nodeId: string, vCtx: JE_JsonValidationContext, errMsg: string, error?: boolean) => {
    addErrorReport(
      vCtx,
      'node',
      nodeId,
      errMsg,
      error !== undefined ? error : true,
      vCtx.nodes[nodeId].flowId,
      vCtx.nodes[nodeId].nodeData?.componentType,
    );
};